import "core-js/modules/es.array.includes.js";
import { initAutoContextNotification } from "../common/auto-context-notification";
import { fetchAutoContextToasterService } from "./services/auto-context-toaster-service";
import { dispatchCustomerAutoContextFailureEvent, dispatchCustomerContextSuccessEvent, dispatchOpeningStoreChoicesModalEvent } from "../common/event-bus";
import { autoContextUserFromCoordinates, getAutoContextHtml } from "./services/auto-context-service";
import { getContextBannerHtml } from "./services/context-banner-service";
import { getContextHeaderHtml } from "./services/context-header-service";
import { addContextHeaderEvent } from "../common/context-header-event";
import { addContextBannerEvent } from "../common/context-banner-event";
import { getRefreshedContextLayerView } from "./services/context-layer-service";
import { retrieveCustomerContextCookieValue } from "../common/cookie-finder";
import { pushFragment } from "../common/tracking-tms";
import { showContextPopover } from "../common/context-popover";
import { showValidContextPopover } from "../common/valid-context-popover";
export const autoContextualizationSuccessKey = 'autoContextualizationSuccess';
class AutoContextualization extends lm.Composant {
  constructor(componentName) {
    super(componentName);
    initAutoContextualization();
  }
}
function initAutoContextualization() {
  pushFragment('autocontextualization_init', true);
  const autoContextualizationSelector = getAutoContextualisationSelector();
  if (!autoContextualizationSelector) return;
  const isNotContextualizedAfterConsent = autoContextualizationSelector.dataset.isnotcontextualizedafterconsent === "true";
  const isOpeningModal = autoContextualizationSelector.dataset.isopeningmodal === "true";
  if (isNotContextualizedAfterConsent && isOpeningModal) {
    dispatchOpeningStoreChoicesModalEvent();
  }
  setTimeout(() => {
    if (sessionStorage.getItem(autoContextualizationSuccessKey) === 'true') {
      showValidContextPopover();
      sessionStorage.setItem(autoContextualizationSuccessKey, 'false');
    }
  }, 1000);
  const isAutoContextualized = autoContextualizationSelector.dataset.isautocontextualized;
  const customerContextCookieValue = retrieveCustomerContextCookieValue();
  if (isAutoContextualized !== 'true') {
    if (customerContextCookieValue == null && navigator.geolocation) navigator.geolocation.getCurrentPosition(handleSuccessOnNavigatorGeolocation, showContextPopover);
  }
  if (isAutoContextualized == null) return;
  if (isAutoContextualized === "false") {
    handleAutoContextFail();
    return;
  }
  handleAutoContextSuccess(customerContextCookieValue['auto_context'] === 'true' ? 'ip' : 'queryParams');
}
export function getAutoContextualisationSelector() {
  return document.querySelector(`[data-selectorid="auto-contextualization"]`);
}
function getContextBannerSelector() {
  return document.querySelector(`[data-selectorid="context-banner"]`);
}
function getContextHeaderSelector() {
  return document.querySelector(`[data-selectorid="context-header"]`);
}
function getContextLayerSelector() {
  return document.querySelector(`[data-selectorid="component-context-layer"]`);
}
function refreshContextBanner() {
  getContextBannerHtml(contextBannerFragment => {
    const contextBannerSelector = getContextBannerSelector();
    if (!contextBannerSelector) return;
    contextBannerSelector.outerHTML = contextBannerFragment;
    addContextBannerEvent();
  });
}
function refreshContextHeader() {
  getContextHeaderHtml(contextHeaderFragment => {
    const contextHeaderSelector = getContextHeaderSelector();
    if (!contextHeaderSelector) return;
    contextHeaderSelector.outerHTML = contextHeaderFragment;
    addContextHeaderEvent();
  });
}
function refreshContextLayer() {
  getRefreshedContextLayerView(contextLayerFragment => {
    const contextLayerSelector = getContextLayerSelector();
    if (!contextLayerSelector) return;
    contextLayerSelector.outerHTML = contextLayerFragment;
    window.dispatchEvent(new Event("refreshContextLayerJs"));
  });
}
export function refreshVisibleFragments() {
  refreshContextBanner();
  refreshContextHeader();
  refreshContextLayer();
  refreshAutoContextFragment();
}
export function handleAutoContextSuccess(contextType) {
  dispatchCustomerContextSuccessEvent();
  if (contextType) pushFragment('cdl_user_context_type', contextType);
  const autoContextualizationSelector = getAutoContextualisationSelector();
  if (!autoContextualizationSelector) return;
  const reloadOnContextualizationSuccess = autoContextualizationSelector.dataset.reloadoncontextualizationsuccess === "true";
  if (reloadOnContextualizationSuccess) {
    sessionStorage.setItem(autoContextualizationSuccessKey, 'true');
    window.location.replace(autoContextualizationSelector.dataset.redirecturl ??= window.location.href);
  } else {
    fetchAutoContextToasterService(toasterRendering => {
      autoContextualizationSelector.innerHTML = toasterRendering;
      const autoContextToaster = document.querySelector(`[data-selectorid="auto-context-toaster"]`);
      initAutoContextNotification(autoContextToaster);
    });
  }
  refreshVisibleFragments();
}
export function handleSuccessOnNavigatorGeolocation(position) {
  if (position && position.coords) {
    autoContextUserFromCoordinates(position.coords, "geolocation");
  }
}
export function handleAutoContextFail() {
  dispatchCustomerAutoContextFailureEvent();
  const autoContextualizationSelector = getAutoContextualisationSelector();
  if (!autoContextualizationSelector) return;
  const isOpeningModal = autoContextualizationSelector.dataset.isopeningmodal === "true";
  if (isOpeningModal) dispatchOpeningStoreChoicesModalEvent();
}
export function hasCustomizationGroupValueConsent() {
  const optanonConsentCustomizationGroupValue = 'C0003:1';
  const cookieConsent = document.cookie.split(';').filter(cookie => cookie.trim().startsWith('OptanonConsent')).values().next().value;
  return decodeURIComponent(cookieConsent).includes(optanonConsentCustomizationGroupValue);
}
export function onUserConsentChange() {
  hasCustomizationGroupValueConsent() ? refreshAutoContextFragment() : handleAutoContextFail();
}
function refreshAutoContextFragment() {
  getAutoContextHtml(autoContextFragment => {
    const autoContextualizationSelector = getAutoContextualisationSelector();
    if (!autoContextualizationSelector) return;
    autoContextualizationSelector.outerHTML = autoContextFragment;
    initAutoContextualization();
  }, handleAutoContextFail);
}
lm.DOMReady(() => {
  new AutoContextualization('autocontextualization');
});